<template>
    <b-overlay :show="form.busy">
        <!-- Form -->
        <form @submit.prevent="submit" :novalidate="true">

            <!-- Field -->
            <b-form-group :label="__('invite.Email')" :description="__('invite.Email Description')">
                <b-form-input
                    v-model="form.email"
                    :class="{ 'is-invalid': form.errors.has('email') }"
                ></b-form-input>
                <has-error :form="form" field="email"></has-error>
            </b-form-group>

            <!-- Submit -->
            <b-button type="submit" variant="primary" :disabled="form.busy">
                <i class="fa fa-envelope mr-1"></i>
                {{ __('invite.Send Invitation') }}
            </b-button>

        </form>
    </b-overlay>
</template>

<script>
import { Form } from "vform";

export default {
    props: ['locale'],
    data() {
        return {
            loading: false,
            form: new Form({
                email: null,
            })
        }
    },
    methods: {

        submit() {
            this.form.post('/' + this.locale + '/invite/send-invitation')
                .then(result => {

                    // Clear Form
                    this.form.email = null;

                    // Notification
                    this.$toast.success(result.message);

                })
        },

    }
}
</script>

<style scoped>

</style>
